import { Component, Inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ServiceBase, SnackbarFactory } from '@shared/services';
import { ICellRendererParams } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { FileLookPopupComponent } from '@shared/components';

@Component({
  selector: 'app-file-save-renderer',
  templateUrl: './file-save-renderer.component.html',
  styleUrls: ['./file-save-renderer.component.scss'],
})
export class FileSaveRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public processingFiles: boolean = false;

  private fileColName: string;
  private fileUploadNameColName?: string;

  constructor(
    public service: ServiceBase<any>,
    public snackBar: SnackbarFactory,
    public dialog: MatDialog,
    @Inject(String) fileColName: string,
    @Inject(String) fileUploadNameColName?: string,
  ) {
    this.fileColName = fileColName;
    this.fileUploadNameColName = fileUploadNameColName ?? `${this.fileColName}UploadName`;
  }

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  // other parts of the component

  downloadhAttachmentFile(fileName: string) {
    this.processingFiles = true;
    this.service.getFile(fileName).subscribe({
      next: (file) => {
        this.handleFile(file, fileName);
      },
      error: (r) => {
        this.snackBar.showButtonSnackbarWithText(
          r.status,
          `${r.status} - ${r.statusText}`
        );
      },
    });
    this.processingFiles = false;
  }

  onClick(event) {
    if (!this.params.data?.[this.fileColName] && this.params.data?.[this.fileUploadNameColName]) {
      this.downloadhAttachmentFile(this.params.data[this.fileUploadNameColName]);
    } else {
      let file = this.params.data[this.fileColName];
      let fileName = this.params.data[this.fileUploadNameColName];
      if (file && fileName) {
        this.handleFile(file, fileName);
      } else {
        this.snackBar.showButtonSnackbarWithText(404, `error`);
      }
    }
    return false;
  }

  handleFile(file: Blob, fileName: string) {
    let splitName = fileName.split('.');
    let fileExt = splitName[splitName.length - 1].toLowerCase();
    let fileType = null;

    let imageTypes = [
      'png',
      'jpg',
      'jpeg',
      'webp' /*, "apng", "avif", "gif", "jfif", "pjpeg", "pjp", "svg"*/,
    ]; //TODO: test with these filetypes
    let pdfTypes = ['pdf'];

    if (imageTypes.includes(fileExt)) {
      fileType = 'img';
    }
    if (pdfTypes.includes(fileExt)) {
      fileType = 'pdf';
    }

    if (fileType) {
      const dialogRef = this.dialog.open(FileLookPopupComponent, {
        width: '1000px',
        data: { file, fileName, fileType },
      });
    } else {
      FileSaver.saveAs(file, fileName);
      this.snackBar.showDurationSnackbar('success');
    }
  }
}
